export * from "@/components/base-ui/collapsible";
